import _ from "lodash";
import jQuery from 'jquery';
import { Component, ElementRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
// @ts-ignore
import { fields as _fields } from "src/app/models/fields.model";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { SplitViewRevisionsComponent } from "../split-view-revisions/split-view-revisions.page";
import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { StateMachineService } from "src/app/services/machine-state.service";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { ProjectService } from "src/app/services/project.service";
import { ProofreadingHistoryService } from "src/app/services/proofreading-history.service";
import { environment } from "src/environments/environment";
import { MembersService } from "src/app/services/member.service";
import { MemberPermission } from "src/app/models/projects/submodels/members.model";
import { FlowType } from "src/app/models/proofreading.model";
import { TranslateService } from "@ngx-translate/core";
import { MarqueService } from "src/app/services/marque.service";

// @ts-ignore
// const api = require("@modules/cf-api.js").api;
// const api_async = require("@modules/cf-api.js").api_async;

@Component({
    selector: "app-split-view",
    templateUrl: "./split-view-intern-revisions.html",
    styleUrls: ["./split-view-intern-revisions.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SplitViewInternRevisionsComponent extends SplitViewRevisionsComponent {
    @ViewChild('drawer') drawer: ElementRef;
    get historyItem() {
        return {
            intern: this.s_proofreadings.currentHistory?.intern,
            extern: this.s_proofreadings.currentHistory?.extern,
            approval: this.s_proofreadings.currentHistory?.approval,
        };
    }

    get codeArticle(): string {
        return this.project?.custom.general?.id_codearticle || '';
    };

    get last_revision() {
        return this.historyItem.approval?.getLastRelecture();
    }

    get revision_url() {
        return this.s_proofreadingHistories.compare.intern.url.value;
    }

    get urlPackZ() {
        return this.proofreading?.file_url;
    }

    get formated_relecture() {
        return this.proofreading?.flow === FlowType.REPRO ? `V${this.current_relecture}` : `R${this.current_relecture}`;
    }
    get formated_version() {
        return `v${this.current_version}`;
    }
    get in_production() {
        return this.internState?.payload?.flags && this.internState?.payload?.flags['in-production'];
    }
    get main_approver() {
        return this.s_members.getMembersByPerms([MemberPermission.APPROVAL])[0];
        // return this.getMemberByPerm(MemberPermission.APPROVAL)[0];
    }

    get projectID(): string {
        return this.proofreading?.project.ID || '';
    }

    public drawerOpened: boolean = true;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected sanitizer: DomSanitizer,
        protected s_alert: AlertService,
        protected dialog: MatDialog,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected title: Title,
        protected liveco: LivecoAPIService,
        protected s_sm: StateMachineService,
        protected s_proofreadings: ProofreadingService,
        protected s_proofreadingHistories: ProofreadingHistoryService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected translate: TranslateService,
        protected s_marques: MarqueService
        
    ) {
        super(route, router, sanitizer, s_alert, dialog, s_loader, s_auth, title, liveco, s_sm, s_proofreadings, s_proofreadingHistories, s_projects, s_members, s_marques);
        this.subscription.add(this.s_proofreadingHistories.compare.intern.url.subscribe(this.handleRevisionURL.bind(this)));
    }

    async handleRevisionURL(url: any) {
        if (url && !_.isEmpty(url) && _.isString(url)) {
            jQuery("#internRevisionViewLink").attr("src", environment.cfURL + url || '');
        } else {
            jQuery("#internRevisionViewLink").attr("src", "");
        }
    }

    public toggleDrawer = (): void => {
        console.log(this.drawer.nativeElement.classList);
        if (this.drawer.nativeElement.classList.contains('drawer-opened')) {
            this.drawer.nativeElement.classList.remove('drawer-opened');
            this.drawer.nativeElement.classList.add('drawer-closed');
        } else {
            this.drawer.nativeElement.classList.add('drawer-opened');
            this.drawer.nativeElement.classList.remove('drawer-closed');
        }

        this.drawerOpened = !this.drawerOpened;
    };

    openFileInPackZ() {
        if (this.urlPackZ)
            this.s_projects.openFileInPackZ(this.urlPackZ);
    }

    openFolderChild() {
        if (this.project)
            this.s_projects.openFolderChild(this.project);
    }

    toggleIFrameFullScreen() {
        const iframe = document.getElementById('content') as HTMLIFrameElement;
        const header = document.getElementsByTagName('app-header')[0] as HTMLIFrameElement;
        if (this.isFullScreen) {
            iframe?.classList.remove('splitviewFullScreen');
            header?.classList.remove('hidden');

            // document.exitFullscreen();
        } else {
            iframe?.classList.add('splitviewFullScreen');
            header?.classList.add('hidden');
            // iframe.requestFullscreen();
        }
        this.isFullScreen = !this.isFullScreen;
    }

}
